import React from "react";
import {
  Button, DialogActions, DialogContent, Grid
} from '@mui/material';
import Dropdown from "@/common/components/dropdown/dropdown";
import SwitchInput from "@/common/components/switch-input/switch-input";
import AnimateButton from "@/from-theme/components/@extended/AnimateButton";
import { FormattedMessage } from 'react-intl';
import { apiStatuses } from "@/store/api/constants";
import useCreateEditSettings from "./hooks/useCreateEditSettings";
import Spinner from "@/common/components/spinner/spinner";
import ErrorInPage from "@/common/components/error-in-page/error-in-page";
import PropTypes from "prop-types";
import useGetDropdownListByDropdown from "@/common/hooks/useGetDropdownListByDropdown";


function CreateEditNotification({
  closeModal, activeEditId
}) {

  const {
    getDropdownListByDropdownData: dropdownListData,
    getDropdownListByDropdown: getDropdownList,
    getDropdownListByDropdownLoading: dropdownListLoading
  } = useGetDropdownListByDropdown('dropdown');
  const { values, formik,getEditZoneMasterStatus, saveNotificationSettingsStatus, 
    updateZoneMasterStatus, getEditZoneMasterErrMsg } = 
    useCreateEditSettings(activeEditId, getDropdownList);
  const isPending = [saveNotificationSettingsStatus, updateZoneMasterStatus]
  .includes(apiStatuses.pending);
  const { settingModuleId, activeStatus, whatsappIsApplicable, smsIsApplicable, emailIsApplicable, 
  } = values;

  return (
    <>
    {
      getEditZoneMasterStatus === apiStatuses.pending && activeEditId
      && <Spinner />
    }
    {getEditZoneMasterStatus === apiStatuses.rejected && activeEditId && (
      <ErrorInPage message={getEditZoneMasterErrMsg} />
    )}
    {(getEditZoneMasterStatus === apiStatuses.succeeded || !activeEditId) &&
    <form onSubmit={formik.handleSubmit}>
      <DialogContent dividers>
        <Grid container spacing={1.25} style={{ paddingBottom: '175px' }}>
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <Dropdown
              options={dropdownListData}
              loading={dropdownListLoading}
              placeholder="notification-settings-name"
              inputLabel="notification-settings-name"
              value={settingModuleId}
              formik={formik}
              name="settingModuleId"
          
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <SwitchInput
              inputLabel="sms-applicable"
              leftLabel="inactive"
              rightLabel="active"
              value={smsIsApplicable}
              formik={formik}
              name="smsIsApplicable"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <SwitchInput
              inputLabel="email-applicable"
              leftLabel="inactive"
              rightLabel="active"
              value={emailIsApplicable}
              formik={formik}
              name="emailIsApplicable"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <SwitchInput
              inputLabel="whatsapp-applicable"
              leftLabel="inactive"
              rightLabel="active"
              value={whatsappIsApplicable}
              formik={formik}
              name="whatsappIsApplicable"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <SwitchInput
              inputLabel="activeStatus"
              leftLabel="inactive"
              rightLabel="active"
              value={activeStatus}
              formik={formik}
              name="activeStatus"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={closeModal} variant="outlined" disabled={isPending}
         sx={{ mr: 1 }}>
          <FormattedMessage id={"cancel"} />
        </Button>
        <AnimateButton>
          <Button type="submit" variant="contained" disabled={isPending} sx={{ mr: 1 }}>
            <FormattedMessage id={"save"} />
          </Button>
        </AnimateButton>
      </DialogActions>
    </form>
    }
    </>
  )
}

CreateEditNotification.propTypes = {
  closeModal: PropTypes.func.isRequired,
  activeEditId: PropTypes.bool,
};

CreateEditNotification.defaultProps = {
  activeEditId: 0,
};

export default CreateEditNotification;